module.exports = __webpack_public_path__ + "img/gable.27bc854f.jpg";